import { addDays, eachDayOfInterval, maxOfDates, minOfDates, startOfToday } from '@repo/date-time';
import { mapDateToCalendarDay } from '../../calendarCore/utils/mapDateToCalendarDay';
export const getDaysForWeekCalendar = (value, used, flaggedDates, maxDate, minDate) => {
    const overdrawDays = 14;
    const dates = [value[0], value[1], ...used].filter((date) => date instanceof Date);
    if (!dates.length)
        return [];
    const today = startOfToday();
    return eachDayOfInterval({
        start: addDays(minOfDates(dates), -overdrawDays),
        end: addDays(maxOfDates(dates), overdrawDays),
    }).map((date) => mapDateToCalendarDay({
        date,
        flaggedDates,
        today,
        minDate,
        maxDate,
        selectionStart: value[0],
        selectionEnd: value[1],
    }));
};
